import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SymbolValidator, StopPriceValidator, LimitPriceValidator, TrailDollarQtyValidator,
    TrailPctQtyValidator, LimitOffsetValidator, SplitIPCodeValidator, SplitIPPercentValidator, QtyValidator, createDollarQtyValidator } from '../equity-validators.utils';

export function createEquityTradingOrderCoreForm(fb: FormBuilder): FormGroup {
    return fb.group({
        transactionType: ['', Validators.required],
        symId: ['', SymbolValidator],
        ordQty: ['', QtyValidator],
        dollarQty: ['', createDollarQtyValidator(25, 50000)],  // the range value (configurable) will be actually set at run time from server data
        tradeInShares: [true, Validators.required],
        orderType: ['', Validators.required],
        stopPrice: ['', StopPriceValidator],
        limitPrice: ['', LimitPriceValidator],
        duration: ['', Validators.required],
        gtdDate: '',
        solicited: [false, Validators.required],
        accountType: '',
        settlementCcy: '',
        addlOrdData: null,
        floorInst: '',
        trailer: ['', Validators.maxLength(45)],
        discExercised: '',
        fdid: '',
        docLocation: [''],
        trailingBasedOn: '',
        trailDollarQty: ['', TrailDollarQtyValidator],
        trailPctQty: ['', TrailPctQtyValidator],
        limitOffset: ['', LimitOffsetValidator],
        avgPrcAcct: '',
        avgPrcAcctTyp: '',
        avgPrcAcctChkBox: ''
    });
}

export function createEquityTradingOrderCommissionsForm(fb: FormBuilder): FormGroup {
    return fb.group({
        commType: '',
        commissionAmt: '',
        ip: '',
        splitIP1: ['', [Validators.minLength(3), Validators.maxLength(3), Validators.pattern(/^[A-Za-z\d]{3}$/), SplitIPCodeValidator]],
        splitIP1Pct: ['', [Validators.min(1), Validators.max(100), Validators.pattern(/^[1-9]\d{0,2}$/), SplitIPPercentValidator]],
        splitIP2: ['', [Validators.minLength(3), Validators.maxLength(3), Validators.pattern(/^[A-Za-z\d]{3}$/), SplitIPCodeValidator]],
        splitIP2Pct: ['', [Validators.min(1), Validators.max(99), Validators.pattern(/^[1-9]\d?$/), SplitIPPercentValidator]],
        groupId: ['', [Validators.minLength(12), Validators.maxLength(12), Validators.pattern(/^\d+$/)]]
    });
}

export function createEquityTradingOrderAdditionalInfoForm(fb: FormBuilder): FormGroup {
    return fb.group({
        paInd: ['A', Validators.required],
        // discExercised: '',
        addlOrdData: null,
        floorInst: '',
        addlIbdMemo: '',
        trailer: ['', Validators.maxLength(45)],
        sourceOverride: '3',
        trailerDiscExercised: ''
    });
}

export function createEquityTradingOrderRegulatoryInfoForm(fb: FormBuilder): FormGroup {
    return fb.group({
        oatsDeskReceiptDate1: ['', Validators.pattern(/^\d{2}\/\d{2}\/\d{4}$/)],
        oatsDeskReceiptDate2: ['', Validators.pattern(/^\d{2}\/\d{2}\/\d{4}$/)],
        oatsDeskReceiptTime1: ['', Validators.pattern(/^\d{2}:\d{2}:\d{2}$/)],
        oatsDeskReceiptTime2: ['', Validators.pattern(/^\d{2}:\d{2}:\d{2}$/)],
        oatsDeskReceiptZone2: '',
        oatsDeskReceiptZone1: '',
        ordXctnTxt1: '',
        oatsDeskTypeCode1: '',
        oatsDeskTypeCode2: '',
        ordXctnTxt2: '',
        secIbdOrdRcvDate: ['', Validators.pattern(/^\d{2}\/\d{2}\/\d{4}$/)],
        secIbdOrdRcvTime: ['', Validators.pattern(/^\d{2}:\d{2}:\d{2}$/)],
        secIbdOrdRcvDateTime: ['', Validators.pattern(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)],
        secIbdOrdRcvTimeZone: '',
        secTermsAndConditions: '',
        secIbdOrdRcvFromName: '',
        oatsDeskReceiptDateTime1:  ['', Validators.pattern(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)],
        oatsDeskReceiptDateTime2:  ['', Validators.pattern(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)]
    });
}
